<style>
div.el-table .el-table__row .cell {
	padding-top: 8px;
}
</style>
<template>
	<div class="cases-listings">
		<base-header class="pb-6">
			<b-row align-v="center" class="py-3">
				<b-col cols="6">
					<p class="text-muted">Profile</p>
					<h2 class="listing-title d-inline-block mb-0">Cases</h2>
				</b-col>
			</b-row>
		</base-header>
		<b-container fluid class="mt--6" v-loading="is_loading_page" element-loading-text="Fetch Case Listing...">
			<b-card no-body class="px-3 pb-3">
				<el-tabs v-model="current_tab" @tab-click="handleTabClick">
					<el-tab-pane label="Property" name="property" v-if="_gAuth.activeUser('subscription.privileges.scpk_la_property',false)">
						<span slot="label">
							<!-- House-building icon -->
							<b-icon icon="building" class="mr-1"></b-icon>
							Property
						</span>
						<div v-if="current_tab == 'property'">
							<PropertyListing :tableData="tableData" :tablePagination="tablePagination" :tableSummary="tableSummary"
								:tableFilters="filters" @onFilter="setFilter($event)" />
						</div>
					</el-tab-pane>
					<el-tab-pane label="Mortgage" name="mortgage" v-if="_gAuth.activeUser('subscription.privileges.scpk_la_mortgage',false)">
						<span slot="label">
							<b-icon icon="house-door" class="mr-1"></b-icon>
							Mortgage
						</span>
						<div v-if="current_tab == 'mortgage'">
							<MortgageListing :tableData="tableData" :tablePagination="tablePagination" :tableSummary="tableSummary"
								:tableFilters="filters" @onFilter="setFilter($event)" />
						</div>
					</el-tab-pane>
					<el-tab-pane label="Personal Loan" name="personal_loan" v-if="_gAuth.activeUser('subscription.privileges.scpk_la_personal_loan',false)">
							<span slot="label">
									<b-icon icon="credit-card" class="mr-1"></b-icon>
									Personal Loan
							</span>
							<div v-if="current_tab == 'personal_loan'">
								<PersonalLoanListing :tableData="tableData" :tablePagination="tablePagination" :tableSummary="tableSummary"
								:tableFilters="filters" @onFilter="setFilter($event)"/>
							</div>
					</el-tab-pane>
					<el-tab-pane label="Insurance" name="insurance" v-if="_gAuth.activeUser('subscription.privileges.scpk_la_insurance',false)"> 
							<span slot="label">
									<b-icon icon="shield-plus" class="mr-1"></b-icon>
									Insurance
							</span>
							<div v-if="current_tab == 'insurance'">
								<InsuranceListing :tableData="tableData" :tablePagination="tablePagination" :tableSummary="tableSummary"
								:tableFilters="filters" @onFilter="setFilter($event)"/>
							</div>
					</el-tab-pane>
					<el-tab-pane label="Refinance" name="refinance" v-if="_gAuth.activeUser('subscription.privileges.scpk_la_refinance',false)">
							<span slot="label">
									<b-icon icon="wallet2" class="mr-1"></b-icon>
									Refinance
							</span>
							<div v-if="current_tab == 'refinance'">
								<RefinancingListing :tableData="tableData" :tablePagination="tablePagination" :tableSummary="tableSummary"
								:tableFilters="filters" @onFilter="setFilter($event)"/>
							</div>
					</el-tab-pane>
					
					<el-tab-pane label="Other Loan" name="other" v-if="_gAuth.activeUser('subscription.privileges.scpk_la_other_loan',false)">
							<span slot="label">
									<b-icon icon="grid-fill" class="mr-1"></b-icon>
									Other Cases
							</span>
							<div v-if="current_tab == 'other'">
								<OtherLoanListing :tableData="tableData" :tablePagination="tablePagination" :tableSummary="tableSummary"
								:tableFilters="filters" @onFilter="setFilter($event)"/>
							</div>
					</el-tab-pane>
          <el-tab-pane label="Solicitor" name="solicitor"> 
							<span slot="label">
									<b-icon icon="people" class="mr-1"></b-icon>
									Solicitor
							</span>
							<div v-if="current_tab == 'solicitor'">
								<SolicitorListing :tableData="tableData" :tablePagination="tablePagination" :tableSummary="tableSummary"
								:tableFilters="filters" @onFilter="setFilter($event)"/>
							</div>
					</el-tab-pane>
					<!-- <el-tab-pane label="Credit Card" name="credit_card" disabled>
                        <span slot="label">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 576 512"><path fill="currentColor" d="M64 32C28.7 32 0 60.7 0 96v32h576V96c0-35.3-28.7-64-64-64H64zm512 192H0v192c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"/></svg>
                            Credit Card
                        </span>
                        <CreditCardListing />
                    </el-tab-pane>
                    <el-tab-pane label="Investment" name="investment" disabled>
                        <span slot="label">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M320 96H192l-47.4-71.1c-7.1-10.7.5-24.9 13.3-24.9h196.2c12.8 0 20.4 14.2 13.3 24.9L320 96zm-128 32h128c3.8 2.5 8.1 5.3 13 8.4 56.7 36.3 179 114.5 179 279.6 0 53-43 96-96 96H96c-53 0-96-43-96-96 0-165.1 122.3-243.3 179-279.6 4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"/></svg>
                            Investment
                        </span>
                        Investment
                    </el-tab-pane>
                    <el-tab-pane label="Solicitor" name="solicitor" disabled>
                        <span slot="label">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4l106.8 106.7l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4l58.8-58.7l-45.3-45.3l-58.7 58.7l-1.4-1.4z"/></svg>
                            Solicitor
                        </span>
                        Solicitor
                    </el-tab-pane> -->
				</el-tabs>
			</b-card>
		</b-container>
		<ComfirmGenerateCommissionModal ref="confirm-modal" />
	</div>
</template>
<script>
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import { Tabs, TabPane } from 'element-ui'
import PropertyListing from '@/views/Cases/CasesTables/Property/PropertyListingCount'
import MortgageListing from '@/views/Cases/CasesTables/Mortgage/MortgageListingCount'
import PersonalLoanListing from '@/views/Cases/CasesTables/PersonalLoan/PersonalLoanListingCount'
// import CreditCardListing from '@/views/Cases/CasesTables/CreditCard/CreditCardListingCount'
import InsuranceListing from '@/views/Cases/CasesTables/Insurance/InsuranceListingCount'
import RefinancingListing from '@/views/Cases/CasesTables/Refinancing/RefinancingListingCount'
import SolicitorListing from '@/views/Cases/CasesTables/Solicitor/SolicitorListingCount'
import ComfirmGenerateCommissionModal from '@/views/Cases/Modals/ComfirmGenerateCommissionModal'
import OtherLoanListing from '@/views/Cases/CasesTables/OtherLoan/OtherLoanListingCount'
import { mapActions, mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useMessagingStore } from '@/stores/messagingStore'

export default {
	components: {
		PropertyListing,
		MortgageListing,
		PersonalLoanListing,
		// CreditCardListing,
		InsuranceListing,
		RefinancingListing,
		OtherLoanListing,
    SolicitorListing,
		ComfirmGenerateCommissionModal,
		[Tabs.name]: Tabs,
		[TabPane.name]: TabPane,
	},
	data() {
		return {
			is_loading_page: false,
			tableData: [],
			tablePagination: {
				perPageOptions: [5, 10, 25, 50, 100, 500],
				currentPage: 1,
				perPage: 25,
				total: 0,
				from: null,
				to: null
			},
			tableSummary: {},
			filters: {
				is_reset_summary: false,
				is_reset: false,
				page: 1,
				paginate: 25,
				search: {
					prod_id: '',
					prod_customer_id: '',
					prod_loan_officer_id: '',
					prod_ssa_id: '',
					prod_case_no: '',
					prod_customer_name: '',
					prod_customer_basket: '',
					prod_type: '',
					prod_detail_table: '',
					prod_status: '',
					prod_agent_id: '',
					prod_agent_username: '',
					prod_agent_company: '',
					prod_main_status: '',
					prod_total_sales: '',
					prod_submitted_date: '',
					prod_acceptance_date: '',
					prod_custom_identifier: '',
					prod_application_code: '',
					prod_created_by: '',
					prod_updated_by: '',
					prod_bnk_codes: '',
					prod_date_range: {
						type_date: '',
						start_date: '',
						end_date: ''
					},
					prod_bnk_stage_status: '',
					prod_oth_status: ''
				}
			},
			current_tab: 'property',
			products: [],
			search: {},
			IGNORE_STATUS: ['Draft', 'Application Pending', 'Application Rejected'],
			qp_tab: ''

		}
	},
	async created() {
		this.qp_tab = this.$route.query.prod_type;
		if(this.qp_tab){
			this.current_tab = this.qp_tab;
		}
		this.setCurrentTab(this.current_tab)
		this.filters.is_reset_summary = true
		await this.getCases()
		this.getBankList()
	},
	mounted() {
		caseEventBus.$on('refresh-cases', this.getCases);
		if(this.qp_tab){
			this.current_tab = this.qp_tab;
		}
		else if (_gAuth.activeUser('subscription.privileges.scpk_la_property',false)) {
			this.current_tab = 'property'
		} else if (_gAuth.activeUser('subscription.privileges.scpk_la_mortgage',false)) {
			this.current_tab = 'mortgage'
		} else if (_gAuth.activeUser('subscription.privileges.scpk_la_personal_loan',false)) {
			this.current_tab = 'personal_loan'
		} else if (_gAuth.activeUser('subscription.privileges.scpk_la_insurance',false)) {
			this.current_tab = 'insurance'
		} else if (_gAuth.activeUser('subscription.privileges.scpk_la_refinance',false)) {
			this.current_tab = 'refinance'
		} else if (_gAuth.activeUser('subscription.privileges.scpk_la_other_loan',false)) {
			this.current_tab = 'other'
		}
	},
	beforeUnmount() {
		EventBus.$off('refresh-cases', this.getCases)
	},
	computed: {
		...mapState(useProductStore, ['current_tab_type']),
	},
	methods: {
		...mapActions(useCustomerStore, ['getCustomerCount']),
		...mapActions(useProductStore, ['getProducts', 'getBankList', 'setCurrentTab']),
		...mapActions(useMessagingStore, ['getProfileListMessagesSummaries']),
		handleTabClick(tab, event) {
			this.clearFilter()
			this.setCurrentTab(tab.name)
			this.filters.is_reset_summary = true
			this.getCases();
		},
		async getCases() {
			this.is_loading_page = true;
			this.tableData = [];
			this.filters.search.prod_type = this.current_tab_type
			let filtersCopy = {
				...this.filters,
				search: { ...this.filters.search }
			};
			if(this.filters.search.prod_type == "personal_loan" && this.filters.search.prod_main_status != 'no_status') {
				if(this.filters.search.prod_status && this.filters.search.prod_status !== '') {
					filtersCopy.search.prod_bnk_stage_status = [this.filters.search.prod_status];
				} else {
					filtersCopy.search.prod_bnk_stage_status = [];

					await axios.get(services.lookup + 'personal_loan_status', {headers: {...getHeader(), 'Application-Code': 'sas_v2'}})
					.then(res => {
						const personal_loan_status = res.data.data
						personal_loan_status.forEach(status => {
							if(status.group == 'sub' && status.parent_status == this.filters.search.prod_main_status) {
								console.log("Status: ", status.status)
								filtersCopy.search.prod_bnk_stage_status.push(status.status) 
							}
						});
					})
					.catch(e => {
						this.errorFunction(e)
					})
				}

				filtersCopy.search.prod_main_status = ''
			} else if(this.filters.search.prod_type == "personal_loan" && this.filters.search.prod_main_status == 'no_status') {
				filtersCopy.search.prod_bnk_stage_status = 'no_status'
				filtersCopy.search.prod_main_status = ''
			}

			
			const resp = await this.getProducts(filtersCopy);

			let tableSummary = _gHlp.getValue(resp, 'summary');

			this.tablePagination = _gHlp.setPaginate(_gHlp.getValue(resp, 'meta'));
			if (this.filters.is_reset_summary) {
				this.tableSummary = tableSummary;
				this.filters.is_reset_summary = false
			}

			this.tableSummary['total'] = _gHlp.getValue(tableSummary, 'total')

			let tableData = _gHlp.getValue(resp, 'data');
			tableData.forEach(async (el) => {
				this.tableData.push(el)
			});
			this.getProfileListMessagesSummaries('cases',this.tableData);
			this.is_loading_page = false;
		},
		setFilter(event) {
			this.filters = { ...this.filters, ...event };
			if (this.filters.is_reset == true) {
				this.filters = _gHlp.resetFormAttributes(this.filters);
				this.filters.page = 1
				this.filters.is_reset = false;
				this.filters.paginate = 25
				this.filters.is_reset_summary = true;
			}
			this.getCases();
		},
		clearFilter() {
			this.filters = _gHlp.resetFormAttributes(this.filters);
		}
	}
}
</script>